<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { tick } from 'svelte';
import removeEvent from '@cclib/functions/eventGroups/removeEvent.js';
import * as m from '@app/paraglide/messages.js';
async function cutEvents(){
    if (eventGroupState[projectState.selected].selected.length > 0) {
        let textToCopy, range = window?.quillEditor?.getSelection();
        if (range && range.length !== 0 && eventGroupState[projectState.selected].selected.length === 1) {
            textToCopy = window.quillEditor.getText(range.index, range.length);
            window.quillEditor.deleteText(range.index, range.length);
        } else {
            let eventsToCut = [];
            let selectedEvents = eventGroupState[projectState.selected].selected.map(selectedEvent => {return selectedEvent});

            eventGroupState[projectState.selected].selected = [];
            /* Important! */
            await tick();
            selectedEvents.sort((a, b) => {
                return b - a;
            }).forEach(eventIndex => {
                eventsToCut.push(eventGroupState[projectState.selected].events[eventIndex]);
                eventGroupState[projectState.selected] = removeEvent(eventGroupState[projectState.selected],eventIndex);
            });
            
            textToCopy = JSON.stringify(eventsToCut);
        }

        navigator.clipboard.writeText(textToCopy);

        insertHistoryAction({
            name: "cut event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    }
}
</script>

<li class="nav-item" title={m.cut_title()}>
    <a 
        class="nav-link" 
        href="#!/" 
        id="cut-event-btn"
        role="button"
        aria-label={m.cut_aria_label()}
        aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        class:disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0} 
        onclick={cutEvents}
    ><i class="bi bi-scissors"></i></a>
</li>
